import { useAppState } from 'hooks/useAppState';
import { TUserRole } from 'types/state';

export const useUserRoles = (): TUserRole[] => {
  const { user } = useAppState();

  if (user && user.accountInfo) {
    return user.accountInfo.roles;
  }

  return [];
};
